export interface Plan {
  code: string;
  name: string;
  amountMinor: string;
  currency: string;
  billingInterval: 'month' | 'year';
}

export interface BillingOverview {
  plans: Plan[];
  subscription: {
    plan: Plan | null;
    subscription: {
      status: string;
      currentPeriodEnd: string;
      cancelAtPeriodEnd: boolean;
    } | null;
    access: { level: string; reasonCode: string };
    openInvoice: { totalMinor: string; currency: string; dueAt: string } | null;
  } | null;
  invoices: {
    id: string;
    totalMinor: string;
    currency: string;
    dueAt: string;
    status: string;
    paidAt?: string | null;
  }[];
  unavailable: string[];
}

export interface CheckoutResult {
  payment: {
    type: 'pix' | 'provider_page';
    providerPageUrl?: string;
    pixCopyPaste?: string;
    pixQrCodeImage?: string;
  };
}

export const ACCESS_LABELS: Record<string, { label: string; variant: string }> = {
  full: { label: 'Em dia', variant: 'success' },
  warning: { label: 'Atenção', variant: 'warning' },
  limited: { label: 'Acesso limitado', variant: 'danger' },
  regularization_only: { label: 'Regularização necessária', variant: 'danger' },
};

export const STATUS_LABELS: Record<string, string> = {
  pending: 'aguardando pagamento',
  trialing: 'em experimentação',
  active: 'ativa',
  past_due: 'pagamento em atraso',
  suspended: 'suspensa',
  cancel_pending: 'cancelamento agendado',
  canceled: 'cancelada',
  expired: 'expirada',
};

export function fmtMoney(amountMinor: string, currency: string): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(
    Number(amountMinor) / 100,
  );
}

export function fmtDate(value: string): string {
  return new Date(value).toLocaleDateString('pt-BR');
}

export function newIdempotencyKey(): string {
  return `web-${crypto.randomUUID()}`;
}
